import { SolidStatusPill } from '@odo/shared-ui';
import type { RoleScope } from '../../../services/roles';
import { TEAM_SCOPE_LABEL, TEAM_SCOPE_TONE } from './teamScopeColor';

interface TeamScopeTagProps {
    scope: RoleScope;
    className?: string;
}

// Thin wrapper over the shared SolidStatusPill for the one non-table display
// of a team's scope (TeamDrawer's read-only field). teamColumns.tsx's Scope
// column renders the same pill via the `statusColumn` preset, reusing the
// same tone/label maps from teamScopeColor.ts so the two never drift.
export function TeamScopeTag({ scope, className }: TeamScopeTagProps) {
    return (
        <SolidStatusPill
            value={scope}
            label={TEAM_SCOPE_LABEL[scope]}
            toneClassName={TEAM_SCOPE_TONE[scope]}
            className={className}
        />
    );
}
